export const Persistente = (grids: any) => {
  const persistivel: any = {};

  Object.keys(grids ?? {}).forEach((grid) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { filters, page, selectedView, colunas, ...resto } = grids[grid] ?? {};
    persistivel[grid] = resto;
  });

  return persistivel;
};

const gridAux = localStorage.getItem('grids');
const grids = gridAux ? Persistente(JSON.parse(gridAux)) : {};

export type State = {
  grids: any;
};

export const state: State = {
  grids: grids
};
